
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import { useNotification } from "../Notification/notification";
import "./checkout.css";

const Checkout = () => {
  const navigate = useNavigate();
  const { notify } = useNotification();

  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  const [loading, setLoading] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    city: "",
    state: "",
    contact: "",
    paymentMethod: "Card",
  });

  // Load cart
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

    const normalizedCart = storedCart.map((item) => ({
      id: item.id,
      productName: item.productName || item.name,
      productPrice: item.productPrice || item.price,
      productImage: item.productImage || item.image || "",
      quantity: item.quantity || 1,
    }));

    setCartItems(normalizedCart);

    const total = normalizedCart.reduce(
      (sum, item) => sum + item.productPrice * item.quantity,
      0
    );

    setTotalPrice(total);
  }, []);

  // Input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit order
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (loading) return;

  if (cartItems.length === 0) {
    notify("Your cart is empty.", "info");
    return;
  }

  if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    notify("Please enter a valid email address.", "warning");
    return;
  }

  try {
    setLoading(true);
    setOrderSuccess(false);

  
    const orderRes = await fetch(`${API_URL}/api/orders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customer: formData,
        cartItems,
        totalPrice,
      }),
    });

    if (!orderRes.ok) {
      throw new Error("Failed to save order");
    }

   
    const emailRes = await fetch(`${API_URL}/api/email/send-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customer: formData,
        cartItems,
        totalPrice,
      }),
    });

    if (!emailRes.ok) {
      throw new Error("Email failed");
    }

   
    localStorage.removeItem("cart");
    setCartItems([]);
    setTotalPrice(0);

    setLoading(false);
    setOrderSuccess(true);

    notify("Order placed successfully!", "success");

    setTimeout(() => {
      setOrderSuccess(false);
      navigate("/");
    }, 4000);

  } catch (err) {
    console.error(err);
    setLoading(false);
    notify("Something went wrong. Please try again.", "error");
  }
};
  if (loading) {
    return (
      <div className="overlay">
        <div className="overlay-box">
          <div className="spinner"></div>
          <h2>Placing your order...</h2>
          <p>Please wait</p>
        </div>
      </div>
    );
  }

 
  if (orderSuccess) {
    return (
      <div className="overlay">
        <div className="overlay-box success">
          <h1>🎉 Thank You!</h1>
          <p>Your order has been placed successfully.</p>
          <p>We’ve sent confirmation to your email.</p>
          <p>Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-container">
      <h1>Checkout</h1>

      <div className="checkout-content">

        {/* FORM */}
        <form className="checkout-form" onSubmit={handleSubmit}>
          <h2>Billing & Shipping Details</h2>

          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="contact"
            placeholder="Phone Number"
            value={formData.contact}
            onChange={handleChange}
            required
          />

          <h3>Payment Method</h3>

          <select
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleChange}
          >
            {/* <option value="Card">Credit/Debit Card</option>
            <option value="Esewa">Esewa</option> */}
            <option value="COD">Cash on Delivery</option>
          </select>

          <button type="submit" className="place-order-btn">
            Place Order
          </button>
        </form>

        {/* SUMMARY */}
        <div className="order-summary">
          <h2>Order Summary</h2>

          {cartItems.length === 0 ? (
            <p>Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <div key={item.id} className="summary-item">
                {item.productImage && (
                  <img
                    src={item.productImage}
                    alt={item.productName}
                    className="summary-img"
                  />
                )}

                <div>
                  <p>{item.productName}</p>
                  <span>Qty: {item.quantity}</span>
                  <span>Price: Rs {item.productPrice}</span>
                </div>
              </div>
            ))
          )}

          <h3>Total: Rs {totalPrice}</h3>
        </div>

      </div>
    </div>
  );
};

export default Checkout;